import { Icon } from "@/components/Icon";
import { ActionSheet } from "antd-mobile";
import { Action } from "antd-mobile/es/components/action-sheet";
import days from "dayjs";
import { useMemo, useState } from "react";
import { RangeSelectPopup } from "./RangeSelectPopup";
import styles from "./styles.module.scss";

type Direct = "asc" | "desc";
const AMOUNT_ORDER_TYPE: Record<Direct, string> = {
  asc: "低到高",
  desc: "高到低",
};

type DateRange = [string, string];

type DateRangePickerProps = {
  value: DateRange;
  onChange: (value: [string, string]) => void;
  onCancel?: () => void;
};

const actions: Action[] = [
  { text: "今天", key: "today" },
  { text: "近三天", key: "recent3" },
  { text: "近五天", key: "recent5" },
  // { text: "自定义", key: "custom" },
  { text: "近一月", key: "month1" },
  {
    text: "取消",
    key: "cancel",
  },
];
export const DateRangePicker = (props: DateRangePickerProps) => {
  const [visible, setVisible] = useState<boolean>(false);
  const [dateRangeVisible, setDateRangeVisible] = useState<boolean>(false);
  const [action, setAction] = useState<Action>(() => actions[0]);
  const [_value, setValue] = useState<[string, string]>([
    days().format("YYYY-MM-DD"),
    days().format("YYYY-MM-DD"),
  ]);
  const order = useMemo(() => {
    return visible ? "asc" : "desc";
  }, [visible]);

  const onAction = (action: Action, index: number) => {
    const today = days();
    let startDate = today.format("YYYY-MM-DD");
    let endDate = today.format("YYYY-MM-DD");

    if (action.key === "cancel") {
      setVisible(false);
      return typeof props.onCancel === "function" && props.onCancel();
    }
    if (action.key === "custom") {
      setAction(action);
      return setDateRangeVisible(true);
    }
    switch (action.key) {
      case "today":
        break;
      case "recent3":
        startDate = today.subtract(3, "day").format("YYYY-MM-DD");
        break;
      case "recent5":
        startDate = today.subtract(5, "day").format("YYYY-MM-DD");
        break;
      case "month1":
        startDate = today.subtract(30, "day").format("YYYY-MM-DD");
        break;
    }
    setAction(action);
    let value: [string, string] = [startDate, endDate];
    setVisible(false);
    setValue(value);
    typeof props.onChange === "function" && props.onChange(value);
  };

  const onDateSelect = (value: [string, string]) => {
    let startDate = days(value[0]).format("YYYY-MM-DD");
    let endDate = days(value[1]).format("YYYY-MM-DD");
    let newValue: [string, string] = [startDate, endDate];
    setDateRangeVisible(false);
    setVisible(false);
    setValue(newValue);
    typeof props.onChange === "function" && props.onChange(newValue);
  };

  return (
    <>
      <div className={styles.text} onClick={() => setVisible(!visible)}>
        <span>
          {action.text} <Icon name={`order-${order}`} size={"24px"} />{" "}
        </span>
      </div>
      <ActionSheet
        visible={visible}
        actions={actions}
        onAction={onAction}
        onClose={() => setVisible(false)}
      />
      <RangeSelectPopup
        visible={dateRangeVisible}
        data={_value}
        onCancel={() => setDateRangeVisible(false)}
        onSubmit={(val) => onDateSelect(val)}
      />
    </>
  );
};
